import { Bell, Plus } from 'lucide-react'
import { useLocation, Link } from 'react-router-dom'
import { Button } from '@/components/ui/Button'

const titleMap: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/whatsapp': 'WhatsApp',
  '/whatsapp/campanas': 'Campañas',
  '/whatsapp/autoservicio': 'Autoservicio',
  '/whatsapp/humana': 'Gestión humana',
  '/whatsapp/revision': 'Revisión',
  '/voz': 'Agente de voz',
  '/settings': 'Settings',
}

export function Topbar() {
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)
  const breadcrumbs: { label: string; to: string }[] = []
  let acc = ''
  for (const s of segments) {
    acc += `/${s}`
    const label = titleMap[acc] || s
    breadcrumbs.push({ label, to: acc })
  }

  return (
    <div className="bg-white/70 backdrop-blur-md border-b border-slate-200/80 sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-10 py-3 flex items-center justify-between">
        <div className="text-sm text-slate-500 flex items-center gap-2">
          {breadcrumbs.map((b, i) => (
            <span key={b.to} className="flex items-center gap-2">
              {i > 0 && <span className="text-slate-300">/</span>}
              <Link
                to={b.to}
                className={
                  i === breadcrumbs.length - 1
                    ? 'text-navy-700 font-medium'
                    : 'text-slate-600 hover:text-navy-700'
                }
              >
                {b.label}
              </Link>
            </span>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <button className="relative p-2 hover:bg-slate-100 rounded-lg transition">
            <Bell className="w-5 h-5 text-slate-600" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-rose-500 rounded-full ring-2 ring-white" />
          </button>
          <Button variant="amber" size="sm">
            <Plus className="w-3.5 h-3.5" strokeWidth={2.5} />
            Nueva campaña
          </Button>
        </div>
      </div>
    </div>
  )
}
